import React, { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

function RegistrationForm(props: any) {
    const {selectedMembership} = props;
    const [inputValueFullName, setInputValueFullName] = useState('');
    const [inputValueEmail, setInputValueEmail] = useState('');
    const [inputValuePhone, setInputValuePhone] = useState('');
    const [inputValueMessage, setInputValueMessage] = useState('');
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [hasValidationErrors, setHasValidationErrors] = useState({
        fullName: false,
        email: false,
        phone: false,
    });
    const [wasSentSuccessfully, setWasSentSuccessfully] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setIsFormSubmitted(false);
        if (wasSentSuccessfully) {
            setTimeout(() => {
                setTimeout(() => {
                    setWasSentSuccessfully(false);
                }, 500); // Adjust the duration to match your CSS transition
            }, 3500); // Adjust the delay as needed
        }
    }, [wasSentSuccessfully]);


    const handleSubmit = async (e: any) => {
        e.preventDefault();

        emailjs.init('1H_M1wONOhR8QK7dJ');

        const validationErrors = {
            fullName: !inputValueFullName,
            email: !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                inputValueEmail,
            ),
            phone: !inputValuePhone,
        };

        setHasValidationErrors(validationErrors);

        if (!inputValueFullName || !inputValueEmail || !inputValuePhone) {
            console.log('Please fill out all the required fields.');
            return;
        }

        if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(inputValueEmail)) {
            console.log('Please enter a valid email address.');
            return;
        }

        setIsLoading(true);

        // Send the email using emailjs
        try {
            await emailjs.send(
                'service_g4t2lyg', // Replace with your service ID
                'template_kirplpd', // Replace with your template ID
                {
                    to_name: 'Private Gym Schijndel',
                    from_name: inputValueFullName,
                    phone: inputValuePhone,
                    reply_to: inputValueEmail,
                    membership_choice: selectedMembership.title,
                    message: inputValueMessage
                },
                'uOwmX01FNONd17Hgy', // Replace with your user ID
            );

            setInputValueEmail('');
            setInputValueFullName('');
            setInputValuePhone('');
            setInputValueMessage('');
            setWasSentSuccessfully(true);
            setIsFormSubmitted(true);
            setIsLoading(false);
            navigate('/success', {state: {isFormSubmitted: true}});
        } catch (error) {
            setIsLoading(false);
            console.error('Error sending email:', error);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="w-full">
            <div className="flex flex-wrap -mx-3 mb-3">
                <div className="w-full px-3 md:mb-0">
                    <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-first-name"
                    >
                        Volledige Naam
                    </label>
                    <input
                        className={`${
                            hasValidationErrors.fullName
                                ? 'border-red-500'
                                : 'border-gray-200'
                        } appearance-none block w-full bg-gray-50 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-primary-500`}
                        id="grid-full-name"
                        type="text"
                        value={inputValueFullName}
                        onChange={(e) => setInputValueFullName(e.target.value)}
                    />
                    {hasValidationErrors.fullName && (
                        <p className="text-red-500 text-xs italic">
                            Voer alstublieft uw naam in
                        </p>
                    )}
                </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                    <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-email"
                    >
                        E-mail
                    </label>
                    <input
                        className={`${
                            hasValidationErrors.email ? 'border-red-500' : 'border-gray-200'
                        } appearance-none block w-full bg-gray-50 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-primary-500`}
                        id="email"
                        type="email"
                        value={inputValueEmail}
                        onChange={(e) => setInputValueEmail(e.target.value)}
                    />
                    {hasValidationErrors.email && (
                        <p className="text-red-500 text-xs italic">
                            Voer alstublieft een geldig e-mailadres in.
                        </p>
                    )}
                </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-3">
                <div className="w-full px-3 md:mb-0">
                    <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-first-name"
                    >
                        Telefoonnummer
                    </label>
                    <input
                        className={`${
                            hasValidationErrors.phone
                                ? 'border-red-500'
                                : 'border-gray-200'
                        } appearance-none block w-full bg-gray-50 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-primary-500`}
                        id="grid-phone"
                        type="tel"
                        value={inputValuePhone}
                        onChange={(e) => setInputValuePhone(e.target.value)}
                    />
                    {hasValidationErrors.phone && (
                        <p className="text-red-500 text-xs italic">
                            Voer alstublieft uw telefoonnummer in
                        </p>
                    )}

                </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                    <label
                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        htmlFor="grid-message"
                    >
                        Bericht (optioneel)
                    </label>
                    <textarea
                        className={`border-gray-200 no-resize appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-primary-500 h-24 resize-none`}
                        id="message"
                        value={inputValueMessage}
                        onChange={(e) => setInputValueMessage(e.target.value)}
                    ></textarea>
                    <p className="text-gray-400 text-xs">
                        We komen zo spoedig mogelijk bij u in de lucht
                    </p>
                </div>
            </div>


            <div className="flex space-x-4 items-center">
                <button type="submit" className="primary-button">
                    Vraag {selectedMembership.title} aan
                </button>
                {isLoading && <div>{<FontAwesomeIcon icon={faSpinner} spin size="lg" className="text-primary-500"
                                                     style={{fontSize: '24px'}}/>
                }</div>}

            </div>
        </form>
    );
}

export default RegistrationForm;
